module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-popup-header",
    class: _vm.showBottomBorder ? 'vux-1px-b' : ''
  }, [_c('div', {
    staticClass: "vux-popup-header-left",
    on: {
      "click": function($event) {
        return _vm.$emit('on-click-left')
      }
    }
  }, [_vm._t("left-text", function() {
    return [_vm._v(_vm._s(_vm.leftText))]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-popup-header-title"
  }, [_vm._t("title", function() {
    return [_vm._v(_vm._s(_vm.title))]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-popup-header-right",
    on: {
      "click": function($event) {
        return _vm.$emit('on-click-right')
      }
    }
  }, [_vm._t("right-text", function() {
    return [_vm._v(_vm._s(_vm.rightText))]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb96e168","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popup-header/index.vue
// module id = 334
// module chunks = 1